export default {
  name: "FlowButton",
  functional: true,
  props: {
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    const { props } = _vm;
    const { button } = props;
    return (
      <el-popover
        vModel={button.popVisible}
        popper-class="ds-morebutton-popover"
        trigger="manual"
        placement="top"
        class={["ds-button__flow"]}
      >
        {renderFlowButton(h, _vm)}
        {renderMainButton(h, _vm)}
      </el-popover>
    );
  }
};
function renderFlowButton(h, _vm) {
  const { props } = _vm;
  const { owner } = props;
  if (owner.flowButtons.length > 0) {
    return (
      <el-row style={{ width: owner.flowButtons.length > 5 ? "240px" : "80px" }}>
        {_.map(owner.flowButtons, (flow, index) => {
          return (
            <el-col
              key={`flowButtons_${index}`}
              span={owner.flowButtons.length > 5 ? 8 : 24}
              style="width: 80px; margin-bottom: 5px; margin-top: 5px"
            >
              <DsfButton
                key="`isLinkSend_${index}`"
                style="width: 80px; margin-bottom: 5px; margin-top: 5px"
                icon="props.owner.getIcon(flow)"
                disabled="flow.disabled"
                size="props.owner.size"
                type="flow.type"
                title="flow.title"
                icon-position="flow.iconPosition"
                btn-style="'icon-text'"
                hasChild="props.owner.hasChild(flow)"
                on-click={owner.clickHandler(flow, $event)}
              >
                {flow.text}
              </DsfButton>
            </el-col>
          );
        })}
      </el-row>
    );
  }
}
function renderMainButton(h, _vm) {
  const { props } = _vm;
  const { owner, button } = props;
  return (
    <DsfButton
      slot="reference"
      icon={owner.getIcon(button)}
      title={button.title}
      disabled={button.disabled}
      icon-position={button.iconPosition}
      size="size"
      type={button.type}
      btn-style={button.btnStyle}
      on-click={() => owner.addFlowBtns(button)}
    >
      {button.text}
    </DsfButton>
  );
}
